import React, { Component } from "react"
import { connect } from "react-redux"
import { fromJS } from "immutable"
import Panel from "react-bootstrap/lib/Panel"

import Loading from "components/Loading"

import List from "./list"
import { fetchSubmissions } from "./actions"

class GradesSubmitted extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasFetched: false,
      data: fromJS([]),
    }
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchSubmissions()).then(res => {
      if (!res.error) {
        this.setState({
          hasFetched: true,
          data: fromJS(res.payload || {}),
        })
      }
    })
  }

  render() {
    const { hasFetched, data } = this.state
    const { __session } = this.props
    if (!hasFetched) {
      return <Loading />
    }

    const header = (
      <span>
        My Submitted Grades -{" "}
        <strong className="text-info">
          {__session.get("sy")} - {__session.get("sem")}
        </strong>
      </span>
    )

    return (
      <Panel header={header}>
        <List data={data} />
      </Panel>
    )
  }
}

function mapStateToProps(state) {
  return {
    __session: state.auth.get("session"),
  }
}

export default connect(mapStateToProps)(GradesSubmitted)



// WEBPACK FOOTER //
// ./src/containers/GradesSubmitted/index.js